module.exports = __webpack_public_path__ + "static/media/cvv-number-v2.eda55be0.png";